export class AppConfig {

	public static scrollDuration = 1000;

	// Convention

	public static poles = ['bati', 'urba', 'eau', 'voi', 'supp'];
	public static convertionStatus = ['brouillon', 'a_valider', 'valide', 'proposee', 'signee', 'refusee', 'annulee', 'facturee_partiellement', 'a_facturer', 'soldee'];
	public static naturesPrestation = ['amo', 'moe'];
	public static typesMission = ['complete', 'partielle'];

	// Marché

	public static marcheStatus = ['brouillon', 'en_cours', 'termine'];
	public static typesMarche = ['Travaux', 'Fournitures', 'Services'];
	public static typesProcedure = ['MAPA < 90 000 € HT', 'MAPA > 90 000 € HT', 'AOO', 'Procédure négociée', 'Concours', 'Concession'];
	public static typesFournisseur = ['Mandataire', 'Co-traitant', 'Sous-traitant'];
	public static tauxTva = [0, 5.5, 10, 20];
	public static typesIndexation = ['Actualisation', 'Révision', 'Aucune'];

	// Feuilles d'heures

	public static feuillesHeuresAll = ['Direction'];
	public static feuillesHeuresPole = ['Responsable de pôle'];

	// General

	public static waitAfterLoader = 500;
	public static autocompleteStartSearching = 3;
	public static ItemsPerPageList = [10, 20, 50, 100, 500];

	public static maxFileSize = 15; // en Mo
	public static MimeFormatsEditable = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
	public static MimeFormatsViewable = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/svg+xml', 'application/pdf'];
	public static FileExtensionsViewable = ['.png', '.PNG', '.jpeg', '.JPEG', '.jpg', '.JPG', '.gif', '.GIF', '.svg', '.SVG', '.pdf', '.PDF'];

	public static Agence01Nom = 'Agence départementale d\'ingénierie de l\'Ain';
	public static Agence01Adresse = '102 boulevard Edouard Herriot';
	public static Agence01CodePostal = '01000';
	public static Agence01Ville = 'BOURG EN BRESSE';

	// Dolibarr Url

	public static UrlFacture = 'gestion/compta/facture/card.php?mainmenu=billing&facid=';
	public static UrlAdherents = 'gestion/adherents/list.php?leftmenu=members&mainmenu=members';
	public static UrlAdherentsNouveau = 'gestion/adherents/card.php?action=create';
	public static UrlFournisseurs = 'gestion/societe/list.php?type=f&leftmenu=listsuppliers&mainmenu=companies';
	public static UrlFournisseurNouveau = 'gestion/societe/card.php?leftmenu=newsuppliers&mainmenu=companies&action=create&type=f';
	public static UrlCotisations = 'gestion/adherents/subscription/list.php?leftmenu=members&mainmenu=members';
	public static UrlCotisationsMontant = 'gestion/adherents/stats/index.php?leftmenu=menumembersstats&mainmenu=members';
	public static UrlFactures = 'gestion/compta/facture/list.php?leftmenu=customers_bills&mainmenu=billing';
	public static UrlUtilisateurs = 'gestion/user/list.php?leftmenu=users';
	public static UrlUtilisateursNouveau = 'gestion/user/card.php?mainmenu=home&leftmenu=newusers&action=create';
	public static UrlArticles = 'gestion/product/list.php?leftmenu=service&mainmenu=products&type=1';
	public static UrlArticlesNouveau = 'gestion/product/card.php?leftmenu=newservice&mainmenu=products&action=create&type=1';
	public static UrlParametres = 'gestion/admin/index.php?mainmenu=home&leftmenu=setup';
	public static UrlResetPassword = 'user/passwordforgotten.php'

	// FullCalendar

	public static FullCalendarLicenceKey = '0892432457-fcs-1676105422';

	// INSEE

	public static InseeAuthorizationKey = 'WFM0X2I3NzhfWjBwRm5YTm01VGNHNnRGUnZnYTphcHRNMHc5d3pzM0ZfZWZ1S1NWVXBLaFA3Qndh';
}
